import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ErrorContent from '../../components/error/ErrorContent';
import HrbTranslate from '../../components/language/HrbTranslate';
import Section from '../../components/layout/Section';
import DateTime from '../../components/library/common/DateTime';
import HelpLink from '../../components/library/common/HelpLink';
import Skeleton from '../../components/library/loaders/Skeleton';
import { jumpToTop } from '../../services/util/CommonUtil';
import OfficeListTable from './components/OfficeListTable';
import './DistrictSummaryPage.scss';
import districtsService from './services/DistrictsService';

const DistrictSummaryPage = () => {

    const limit = 25;

    const history = useHistory();
    const firstName = useSelector(state => (state.accountData || {}).firstName)

    const [officeList, setOfficeList] = useState(null);
    const [sortType, setSortType] = useState('OfficeId');
    const [reversed, setReversed] = useState(false)
    const [offset, setOffset] = useState(0);
    const [districtFilter, setDistrictFilter] = useState(-1) 
    const [errorCode, setErrorCode] = useState(null)
    const [lastUpdated, setLastUpdated] = useState(null)
    localStorage.setItem('pageSelections', JSON.stringify([]));
    localStorage.setItem('reassignTicketIds', JSON.stringify([]));

    useEffect(() => {
        setOfficeList(null);
        getOfficeList();
    }, [sortType, offset, reversed, districtFilter])

    useEffect(() => {
        const handlePopState = () => {
            setOffset(0);
        }; 
        window.addEventListener('popstate', handlePopState);
 
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
     }, []);

    const getOfficeList = async () => {
        var officeData = await districtsService.getDistrictOfficesList(sortType, reversed, limit, offset, districtFilter)
        if (officeData) {
            if (officeData && (officeData.error_code || officeData.items.length === 0)) {
                setErrorCode(officeData.error_code)
                console.log('error retrieving offices ' + officeData.error_code)
            } else {
                setOfficeList(officeData)
            }
        }

        // timestamp the page
        setLastUpdated(new Date().toUTCString())
    }

    const handleSortChange = (sort, rev) => {
        if (sort !== sortType) {
            setSortType(sort)
            setOffset(0);
        }
        if (reversed !== rev) {
            setReversed(rev)
            setOffset(0);
        }
    }

    const handleFilterChange = districtId => {
        if (districtFilter !== districtId) {
            setDistrictFilter(districtId)
            setOffset(0)
        }
    }

    const handleSetOffset = (offset) => {
        jumpToTop()
        setOffset(offset)
        history.push({ pathname: '/home', state: { offset: offset } });
    }

    const handleOfficeClick = officeId => {
        history.push(`/offices/${officeId}`)
    }

    return (
        <div className="content-grid district-summary" >
            <Section sectionId='section-queue-summary' className='white'>
                {errorCode === 403 &&
                    <ErrorContent errorDetailKey='Errors.NotAllowedDetail' errorTitleKey='Errors.NotAllowedTitle' />
                }
                {!errorCode &&
                    <div className='columns'>
                        <div className='column is-10 is-offset-1 district-summary-header' >
                            <h1>{firstName === null ?
                                <Skeleton /> :
                                <HrbTranslate text='HomePage.Labels.Hello' params={{ FirstName: firstName }} />}
                            </h1>
                        </div>
                    </div>
                }
            </Section>
            {!errorCode &&
                <Section sectionId='section-office-list' className='light-functional-grey'>
                    <div className="columns">
                        <div className='column is-6 is-offset-1'>
                            <h3><HrbTranslate text='DistrictPage.PageTitle' /></h3>
                            <p className='p1 mt-4'>
                                <HrbTranslate text='DistrictPage.PageDescription' />
                            </p>
                            <p className='p1 my-4 has-text-weight-bold'>
                                <HrbTranslate text='DistrictPage.PageLastUpdated' />
                                <DateTime value={lastUpdated} dateAndTime />
                            </p>
                        </div>
                        <div className='column is-2' />
                        <div className='column is-2'>
                            <HelpLink helpKey='0ProSupport/VDOPro/DMDoC_Dashboard.htm' />
                        </div>
                    </div>
                    <OfficeListTable
                        officeList={officeList} districtFilter={districtFilter} limit={limit}
                        sort={sortType} onSortChanged={handleSortChange}
                        onOfficeClicked={handleOfficeClick}
                        onSetOffset={handleSetOffset}
                        onFilterChanged={handleFilterChange} />
                </Section>
            }
        </div>
    )
}

export default DistrictSummaryPage